import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { Observable } from 'rxjs';
import { IAppConfig } from '@core-lib/models/app-config.model';
import { AuthSharedService } from './auth.service';

@Injectable({
	providedIn: 'root'
})
export class ConfigService {
	get(): Observable<IAppConfig> {
		return this.http.get<IAppConfig>(`${environment.apiUrl}/t/${this.authService.currentTenantKey}/Configuration`);
	}

	constructor(private http: HttpClient, private authService: AuthSharedService) {}
}
